import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const comingSoonProducts = [
  {
    name: "Sleep Kit",
    description: "The ultimate collection for restorative beauty sleep. Includes silk pillowcase, sleep mask, and calming essentials.",
    icon: "🌙",
  },
  {
    name: "Wellness Kit",
    description: "Complete self-care bundle featuring our best-selling massage tools and skincare essentials.",
    icon: "✨",
  },
];

export const ComingSoon = () => {
  return (
    <section id="coming-soon" data-testid="coming-soon-section" className="py-24 lg:py-32 bg-[#F8F6F1] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-20 left-10 w-32 h-32 bg-[#DAB668] rounded-full opacity-5 blob" />
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-[#DAB668] rounded-full opacity-5 blob-delayed" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 bg-[#DAB668]/10 text-[#DAB668] px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Sparkles size={16} />
            <span>Coming Soon</span>
          </div>
          <h2 data-testid="coming-soon-heading" className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#2C2C2C] mb-6">
            New Arrivals on the Horizon
          </h2>
          <p className="text-[#6E6A62] max-w-2xl mx-auto">
            Be the first to know when our exclusive kits launch. Sign up below for early access.
          </p>
        </motion.div>

        {/* Coming Soon Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {comingSoonProducts.map((product, index) => (
            <motion.div
              key={product.name}
              data-testid={`coming-soon-card-${index}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="group"
            >
              <div className="bg-white rounded-3xl p-8 lg:p-10 shadow-sm hover:shadow-lg transition-all duration-300 h-full border border-[#E8E4DA]/50">
                <div className="text-5xl mb-6">{product.icon}</div>
                <h3 className="font-serif text-2xl text-[#2C2C2C] mb-4">{product.name}</h3>
                <p className="text-[#6E6A62] leading-relaxed mb-6">{product.description}</p>
                <div className="coming-soon-badge inline-block">
                  Launching Soon
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
